
import { HCVisit } from '../models/Entities/Protocols/HCVisit';
import { apiRequest } from './commons/CommonService.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'protocols/protocols/';

/**
 * Fetches the concepts for a specific visit and patient in a protocol.
 * @param protocolId - Protocol ID
 * @param visitId - Visit ID
 * @param patientId - Patient ID
 * @param token - Authentication token
 * @returns Promise with the visit concepts
 */
export const GetVisitConcepts = async (
    protocolId: number,
    visitId: number,
    patientId: string,
    token: string
): Promise<HCVisit> => {
    const requestURL = `${BaseURL}${protocolId}/visits/${visitId}/patient/${encodeURIComponent(patientId)}/concepts`;
    return await apiRequest<HCVisit>(requestURL, token, 'GetVisitConcepts');
};
